module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pregnancyRegistration"
  }, [_c('div', {
    staticClass: "onpage"
  }, [_c('div', {
    staticClass: "topcontent",
    class: _vm.gonghao != '' ? 'yuangong' : ''
  }, [_c('img', {
    attrs: {
      "src": _vm.topbag
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "btn"
  }, [_c('li', {
    on: {
      "click": _vm.zizhudengji
    }
  }, [_c('h3', [_vm._v("自主登记\n              "), _c('span', [_vm._v("（常用）")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.jt
    }
  })]), _vm._v(" "), _c('p', [_vm._v("直接录入被推荐人相关信息")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basemessage.userId != '' && _vm.gonghao != ''),
      expression: "basemessage.userId !=''&& gonghao !=''"
    }],
    on: {
      "click": _vm.xiezhu
    }
  }, [_c('h3', [_vm._v("协助他人登记\n              "), _c('img', {
    attrs: {
      "src": _vm.jt
    }
  })]), _vm._v(" "), _c('p', [_vm._v("帮朋友/患者录入被推荐人信息")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basemessage.userId != ''),
      expression: "basemessage.userId !=''"
    }],
    on: {
      "click": _vm.tuijianhuanzhe
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("推荐记录\n              "), _c('img', {
    attrs: {
      "src": _vm.jt
    }
  })])]), _vm._v(" "), (_vm.createPostersShow) ? _c('li', {
    on: {
      "click": _vm.createPosters
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("创建海报\n              "), _c('img', {
    attrs: {
      "src": _vm.jt
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.xinanstaff) ? _c('li', {
    on: {
      "click": _vm.collectPosters
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("领取海报\n              "), _c('img', {
    attrs: {
      "src": _vm.jt
    }
  })])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "twopage",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: _vm.showBack,
        preventGoBack: true
      }
    },
    on: {
      "on-click-back": _vm.back
    }
  }, [_vm._v("助孕登记")]), _vm._v(" "), _c('x-textarea', {
    staticStyle: {
      "background": "#fff"
    },
    attrs: {
      "placeholder": "【文字智能识别】粘贴如张三,电话号码,身份证号码,等信息进行智能识别（信息之间请用逗号隔开）",
      "show-counter": false,
      "rows": 4,
      "autosize": ""
    },
    on: {
      "onPaste": _vm.textareaBlur,
      "on-blur": _vm.textareaBlur
    },
    model: {
      value: (_vm.fontTxt),
      callback: function($$v) {
        _vm.fontTxt = $$v
      },
      expression: "fontTxt"
    }
  }), _vm._v(" "), _c('group', {
    attrs: {
      "title": "患者信息录入"
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('popup-radio', {
    attrs: {
      "required": "",
      "title": "初诊类型",
      "placeholder": "请选择",
      "options": _vm.firstVisitoptions
    },
    on: {
      "on-change": _vm.firstVisitChange
    },
    model: {
      value: (_vm.basemessage.preVisitType),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "preVisitType", $$v)
      },
      expression: "basemessage.preVisitType"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preVisitTypeIcon),
      expression: "preVisitTypeIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('cell', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "title": "性别",
      "value-align": "right"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.fuzhi('sex')
      }
    },
    model: {
      value: (_vm.basemessage.sex),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "sex", $$v)
      },
      expression: "basemessage.sex"
    }
  }, _vm._l((_vm.sexoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  })), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sexIcon),
      expression: "sexIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必选哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "text-align": "right",
      "title": "姓名",
      "placeholder": "请输入姓名"
    },
    on: {
      "on-change": function($event) {
        _vm.fuzhi('name')
      }
    },
    model: {
      value: (_vm.basemessage.name),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "name", $$v)
      },
      expression: "basemessage.name"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nameIcon),
      expression: "nameIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "text-align": "right",
      "max": 11,
      "is-type": _vm.chinamobile,
      "title": "手机号码",
      "placeholder": "请输入手机号码"
    },
    on: {
      "on-change": function($event) {
        _vm.fuzhi('phone')
      }
    },
    model: {
      value: (_vm.basemessage.phone),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "phone", $$v)
      },
      expression: "basemessage.phone"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneIcon),
      expression: "phoneIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "novalidate": "",
      "icon-type": _vm.SFZiconType,
      "text-align": "right",
      "title": "身份证号码",
      "placeholder": "请输入身份证号码"
    },
    on: {
      "on-blur": _vm.Sfzvalidate
    },
    model: {
      value: (_vm.basemessage.certNo),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "certNo", $$v)
      },
      expression: "basemessage.certNo"
    }
  }), _vm._v(" "), (_vm.userIdent == 'adviser' && (_vm.basemessage.preVisitType == '01' || _vm.basemessage.preVisitType == '04' || _vm.basemessage.preVisitType == '05')) ? _c('div', {
    staticClass: "relative"
  }, [_c('cell', {
    attrs: {
      "title": "转诊院区"
    },
    nativeOn: {
      "click": function($event) {
        _vm.anothdoctorClick('hospital')
      }
    },
    model: {
      value: (_vm.basemessage.channelCardNo),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "channelCardNo", $$v)
      },
      expression: "basemessage.channelCardNo"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "转诊医生"
    },
    nativeOn: {
      "click": function($event) {
        _vm.anothdoctorClick('doctor')
      }
    },
    model: {
      value: (_vm.basemessage.channelOutDoctor),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "channelOutDoctor", $$v)
      },
      expression: "basemessage.channelOutDoctor"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "所属片区"
    },
    nativeOn: {
      "click": function($event) {
        _vm.anothdoctorClick('area')
      }
    },
    model: {
      value: (_vm.belongAreaName),
      callback: function($$v) {
        _vm.belongAreaName = $$v
      },
      expression: "belongAreaName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.basemessage.channelId == '5' && _vm.userIdent != 'adviser') ? _c('cell', {
    attrs: {
      "title": "就诊服务",
      "value": _vm.serviceType
    }
  }) : _vm._e(), _vm._v(" "), _c('x-textarea', {
    attrs: {
      "placeholder": "备注",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.basemessage.remark),
      callback: function($$v) {
        _vm.$set(_vm.basemessage, "remark", $$v)
      },
      expression: "basemessage.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('x-button', {
    staticClass: "orangeBtn",
    staticStyle: {
      "margin": "15px auto",
      "width": "95%"
    },
    attrs: {
      "disabled": _vm.submitdisabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0 auto",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px",
      "height": "auto",
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "margin": "-15px 0 0 -15px"
    },
    attrs: {
      "src": _vm.wexinlogo
    },
    on: {
      "click": function($event) {
        _vm.zhezhaoshow = true
      }
    }
  }), _vm._v(" "), _c('qrcode', {
    attrs: {
      "size": 80,
      "type": "img"
    },
    nativeOn: {
      "click": function($event) {
        _vm.zhezhaoshow = true
      }
    },
    model: {
      value: (_vm.qrcodeUrl),
      callback: function($$v) {
        _vm.qrcodeUrl = $$v
      },
      expression: "qrcodeUrl"
    }
  })], 1)]), _vm._v(" "), ((_vm.gonghao || _vm.basemessage.channelId == '2' || (_vm.basemessage.channelId == '5' && _vm.userIdent == 'adviser')) && !_vm.$route.query.sfzh && !_vm.$route.query.channelIdent) ? _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("工号：" + _vm._s(_vm.gonghao))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "dectionp"
  }, [_vm._v("助孕登记——锁定贵宾身份，开启便捷就医")]), _vm._v(" "), (_vm.basemessage.channelId != '5' && !_vm.$route.query.sfzh && !_vm.$route.query.channelIdent) ? _c('p', {
    staticClass: "dectionp"
  }, [_vm._v("助孕登记有以下两种方式 (任选其一)：")]) : _vm._e(), _vm._v(" "), (_vm.basemessage.channelId != '5' && !_vm.$route.query.sfzh && !_vm.$route.query.channelIdent) ? _c('p', {
    staticClass: "dectionp"
  }, [_vm._v("1.扫描二维码,填写个人信息,即可完成身份锁定(推荐)。")]) : _vm._e(), _vm._v(" "), (_vm.basemessage.channelId != '5' && !_vm.$route.query.sfzh && !_vm.$route.query.channelIdent) ? _c('p', {
    staticClass: "dectionp"
  }, [_vm._v("2.致电027-82889968,在线客服协助完成身份锁定。")]) : _vm._e(), _vm._v(" "), (_vm.basemessage.channelId == '5' || _vm.$route.query.sfzh || _vm.$route.query.channelIdent) ? _c('p', {
    staticClass: "dectionp"
  }, [_vm._v("请完善个人信息，工作人员即将为您开启专属服务")]) : _vm._e(), _vm._v(" "), (((_vm.basemessage.channelId == '5' && _vm.userIdent == 'adviser') || (_vm.basemessage.channelId != '5')) && !_vm.$route.query.sfzh && !_vm.$route.query.channelIdent) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basemessage.userId != '' && _vm.gonghao != ''),
      expression: "basemessage.userId !=''&& gonghao !=''"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "alook",
    on: {
      "click": _vm.tuijianhuanzhe
    }
  }, [_vm._v("查看推荐患者明细")])])]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zhezhaoshow),
      expression: "zhezhaoshow"
    }],
    staticClass: "zhezhao",
    on: {
      "click": function($event) {
        _vm.zhezhaoshow = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "40% 0 0"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0 auto",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "36px",
      "height": "auto",
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "margin": "-18px 0 0 -18px"
    },
    attrs: {
      "src": _vm.wexinlogo
    }
  }), _vm._v(" "), _c('qrcode', {
    attrs: {
      "size": 200,
      "value": _vm.qrcodeUrl,
      "type": "img"
    }
  })], 1)])])]), _vm._v(" "), _c('x-dialog', {
    staticClass: "dialog-demo",
    model: {
      value: (_vm.guanzhushow),
      callback: function($$v) {
        _vm.guanzhushow = $$v
      },
      expression: "guanzhushow"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "15px 15px"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.guanzhuTxt))]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("长按识别二维码"), _c('br'), _vm._v("关注微信公众号"), _c('br')]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": _vm.gzherCodeImg
    }
  }), _vm._v(" "), _c('x-button', {
    staticClass: "orangeBtn",
    attrs: {
      "type": "default"
    },
    nativeOn: {
      "click": function($event) {
        _vm.guanzhushow = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.anothhospitaldialog),
      expression: "anothhospitaldialog"
    }],
    staticClass: "seachDialog",
    staticStyle: {
      "overflow-y": "scroll",
      "background": "#fff",
      "position": "fixed",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "z-index": "2"
    }
  }, [_c('search', {
    ref: "search",
    attrs: {
      "auto-fixed": false,
      "results": _vm.seachdialogresults
    },
    on: {
      "result-click": _vm.dialogresultClick,
      "on-change": _vm.hospitaldialogResult
    },
    model: {
      value: (_vm.hospitaldialogvalue),
      callback: function($$v) {
        _vm.hospitaldialogvalue = $$v
      },
      expression: "hospitaldialogvalue"
    }
  }), _vm._v(" "), (_vm.hospitalShow) ? _c('group', _vm._l((_vm.seachdialogresults), function(item, index) {
    return _c('cell', {
      key: index,
      attrs: {
        "title": item
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogresultClick(item)
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.doctorShow) ? _c('group', _vm._l((_vm.seachdialogresults), function(item, index) {
    return _c('cell', {
      key: index,
      attrs: {
        "title": item.outDocker
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogresultClick(item)
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.areaShow) ? _c('group', _vm._l((_vm.seachdialogresults), function(item, index) {
    return _c('cell', {
      key: index,
      attrs: {
        "title": item.value
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogresultClick(item)
        }
      }
    })
  })) : _vm._e()], 1)]), _vm._v(" "), _c('toast', {
    attrs: {
      "width": "80%",
      "is-show-mask": "",
      "position": "middle",
      "time": 2000,
      "type": "text"
    },
    model: {
      value: (_vm.toastshow),
      callback: function($$v) {
        _vm.toastshow = $$v
      },
      expression: "toastshow"
    }
  }, [_vm._v(_vm._s(_vm.toastTxt))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ca57240","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/pregnancyProject/pregnancyRegistration.vue
// module id = Mmx9
// module chunks = 5